import gql from 'graphql-tag';

const CREATE_MAILBOX = gql`
  mutation($mailboxInput: CreateMailboxInput!) {
    createMailbox(input: $mailboxInput) {
      boxId
      type
      incomingAddress
      outgoingAddress
      outgoingAddressType # OutgoingAddressType
      senderConfiguration {
        verificationRecords {
          recordType
          host
          value
        }
      }
      outgoingDomainVerified
      onBehalfOf #ConversationOnBehalf
      senderName
      emailSignature
      client {
        accountId
        name
      }
    }
  }
`;

const UPDATE_MAILBOX = gql`
  mutation($mailboxInput: UpdateMailboxInput!) {
    updateMailbox(input: $mailboxInput) {
      boxId
      type
      incomingAddress
      outgoingAddress
      outgoingAddressType # OutgoingAddressType
      senderConfiguration {
        verificationRecords {
          recordType
          host
          value
        }
      }
      outgoingDomainVerified
      onBehalfOf #ConversationOnBehalf
      senderName
      emailSignature
      client {
        accountId
        name
      }
    }
  }
`;

const DELETE_MAILBOX = gql`
  mutation($boxId: ID!) {
    deleteMailbox(boxId: $boxId)
  }
`;

const VERIFY_OUTGOING_DOMAIN = gql`
  mutation($boxId: ID!) {
    verifyOutgoingDomain(boxId: $boxId)
  }
`;

const VERIFY_CUSTOM_MAIL_SERVER_CONNECTION = gql`
  query($input: VerifyCustomMailServerConnectionInput) {
    verifyCustomMailServerConnection(input: $input)
  }
`;

const UPDATE_MAILBOX_ENABLED_STATUS = gql`
  mutation updateMailboxEnabledStatus(
    $input: UpdateMailboxEnabledStatusInput!
  ) {
    updateMailboxEnabledStatus(input: $input) {
      mailboxType
      enabled
    }
  }
`;

export {
  CREATE_MAILBOX,
  UPDATE_MAILBOX,
  DELETE_MAILBOX,
  VERIFY_OUTGOING_DOMAIN,
  VERIFY_CUSTOM_MAIL_SERVER_CONNECTION,
  UPDATE_MAILBOX_ENABLED_STATUS
};
